(() => {
  if (customElements.get('rss-product-dialog')) return;
  customElements.define('rss-product-dialog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('.rss-info-dialog__body');
      this.heading = this.querySelector('h2');
      this.scope = this.closest('.rss-purchase-confidence');
      this.scope?.addEventListener('click', event => {
        const trigger = event.target.closest('[data-rss-info-source]');
        if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
        const source = document.getElementById(trigger.dataset.rssInfoSource);
        const original = source instanceof HTMLTemplateElement ? source.content : source?.querySelector('.facet-content');
        if (!original) return;
        this.opener = trigger;
        this.heading.textContent = trigger.textContent.trim();
        const copy = document.createDocumentFragment();
        original.childNodes.forEach(node => copy.appendChild(node.cloneNode(true)));
        const policyRange = source.dataset.rssPolicyRange;
        const policySections = [...copy.querySelectorAll('[data-rss-policy-range]')];
        if (policyRange && policySections.some(node => node.dataset.rssPolicyRange === policyRange)) {
          policySections.forEach(node => {
            if (node.dataset.rssPolicyRange !== 'all' && node.dataset.rssPolicyRange !== policyRange) node.remove();
          });
        } else if (policyRange) {
          const headings = new Map([
            ['Thermoplastic road and playground markings', 'thermoplastic'],
            ['Safety signs, sign fixings and mounting accessories', 'signs'],
            ['Logs, firewood, kindling and solid fuel', 'fuel'],
            ['Other products', 'other'],
            ['Consumer cancellation rights and refunds', 'all'],
            ['Faulty, damaged or incorrect goods', 'all'],
            ['Contact and return instructions', 'all'],
            ['Delivery problems and help', 'all']
          ]);
          const headingNodes = [...copy.querySelectorAll('h1,h2,h3,h4,p')].filter(node => headings.has(node.textContent.trim()));
          if (headingNodes.some(node => headings.get(node.textContent.trim()) === policyRange)) {
            const fragments = [];
            let start = null;
            let activeRange = 'all';
            const appendRange = end => {
              if (activeRange !== 'all' && activeRange !== policyRange) return;
              const range = document.createRange();
              range.selectNodeContents(copy);
              if (start) range.setStartBefore(start);
              if (end) range.setEndBefore(end);
              fragments.push(range.cloneContents());
            };
            headingNodes.forEach(heading => {
              appendRange(heading);
              start = heading;
              activeRange = headings.get(heading.textContent.trim());
            });
            appendRange(null);
            copy.replaceChildren(...fragments);
          }
        }
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        copy.querySelectorAll('a').forEach(link => {
          if (!/^(tel:|mailto:)/i.test(link.getAttribute('href') || '')) link.replaceWith(...link.childNodes);
        });
        this.content.replaceChildren(copy);
        this.dialog.showModal();
        this.content.scrollTop = 0;
        document.body.classList.add('rss-info-dialog-open');
      }, options);
      this.querySelector('[data-rss-info-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('rss-info-dialog-open');
        this.content.replaceChildren();
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) document.body.classList.remove('rss-info-dialog-open');
      this.ready = false;
    }
  });
})();
